import React from 'react';
import { FaExpand } from 'react-icons/fa'; 

const ExpandButton = ({ onClick, label = "Expand", className = '', style = {} }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`btn btn-sm d-flex align-items-center justify-content-center ${className}`}
      style={{
        height: '31px',
        width: '31px',
        padding: 0,
        fontSize: '0.75rem',
        backgroundColor: '#585485',
        color: '#fff',
        border: '1px solid #ced4da',
        borderRadius: '0.2rem',
        ...style,
      }}
    >
      <FaExpand />
    </button>
  );
};

export default ExpandButton;
